const styles = (theme) => ({
  img: {
    width: '100%',
  },
  boxLevel: {
    border: `1px solid ${theme.palette.line.main}`,
    '&:nth-of-type(even)': {
      borderRight: '0px solid #ccc',
      borderLeft: '0px solid #ccc',
    },
  },
  title: {
    textAlign: 'center',
    fontSize: '10px',
    fontFamily: theme.typography.fontKanit,
  },
  color: {
    fontSize: '0.7rem',
    textAlign: 'center',
    fontFamily: theme.typography.fontKanit,
    whiteSpace: 'nowrap',
    height: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '-webkit-fill-available',
    },
  },

  // color
  // color
  color0: {
    background: '#AED3FF',
    constrastColor: '#000',
  },
  color10: {
    background: '#AEECB7',
    constrastColor: '#000',
  },
  color20: {
    background: '#80C63D',
    constrastColor: '#000',
  },
  color35: {
    background: '#F0D447',
    constrastColor: '#000',
  },
  color50: {
    background: '#F08F36',
    constrastColor: '#000',
  },
  color70: {
    color: '#fff',
    background: '#BE6B27',
    constrastColor: '#fff',
  },
  color90: {
    color: '#fff',
    background: '#DB352E',
    constrastColor: '#fff',
  },

  // color
  colorRain0: {
    background: '#fff',
    constrastcolor: '#000',
  },
  colorRain1: {
    background: '#cce3ff',
    constrastcolor: '#000',
  },
  colorRain2: {
    background: '#A9CEFC',
    constrastColor: '#000',
  },
  colorRain3: {
    background: '#9CEEB2',
    constrastColor: '#000',
  },
  colorRain4: {
    background: '#66C803',
    constrastColor: '#000',
  },
  colorRain5: {
    background: '#F6D300',
    constrastColor: '#000',
  },
  colorRain6: {
    background: '#FE8A04',
    constrastColor: '#000',
  },
  colorRain7: {
    background: '#CA6504',
    constrastColor: '#000',
  },
  colorRain8: {
    color: '#fff',
    background: '#EE141F',
    constrastColor: '#fff',
  },
  colorRain9: {
    color: '#fff',
    background: '#CC2723',
    constrastColor: '#fff',
  },
  colorRain10: {
    color: '#fff',
    background: '#891B1D',
    constrastColor: '#fff',
  },
  colorRain11: {
    color: '#fff',
    background: '#9931CF',
    constrastColor: '#fff',
  },
});

export default styles;
